module.exports = __webpack_public_path__ + "static/37-85d374abfa95c940ce561ae5c94fe538.jpg";